module.exports = __webpack_public_path__ + "efa06dec00d7abb83c0bbc2a6da4ced1.pdf";